













import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { DocumentMultiValueReferencesModel, DataTableColumnsModel } from '@/services/GeneratedApi';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default Vue.extend({
  name: 'MStoreMultiValueReferences',
  props: {
    cabinetId: {
      type: String,
      required: true
    },
    documentId: {
      type: Number,
      required: true
    },
    documentTypeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      hasError: false,
      errorMessage: '',
      currentPage: 1,
      multiValueReferencesModel: {} as DocumentMultiValueReferencesModel
    };
  },
  computed: {
    hasMultiValueReferences(): boolean {
      return this.multiValueReferencesModel?.hasMultiValueReferences ?? false;
    },
    multiValueReferenceData(): any[] {
      const data = this.multiValueReferencesModel?.data;
      if (!data) {
        return [];
      }
      return (data as any) || [];
    },
    multiValueReferenceColumns(): DataTableColumnsModel[] {
      return (this.multiValueReferencesModel?.columns ?? []).map(({ key, label }) => ({ key, description: label }));
    }
  },
  methods: {
    async loadMultiValueReferences(this: any) {
      try {
        this.isLoading = true;
        this.hasError = false;
        this.errorMessage = '';
        const response = await ApiConfiguration.api().document.documentMultiValueReferencesList({
          CabinetId: this.cabinetId,
          DocumentId: this.documentId,
          DocumentTypeId: this.documentTypeId,
          HasDocumentTypeId: true
        });

        this.multiValueReferencesModel = response;
      } catch (error) {
        this.hasError = true;
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.loadMultiValueReferences();
  },
  watch: {
    documentId: {
      handler() {
        this.loadMultiValueReferences();
      }
    }
  },
  components: {
    LoadingSpinner,
    MStoreSimpleTable: () => import('@/components/shared/Table/MStoreSimpleTable.vue')
  }
});
